module.exports = __webpack_public_path__ + "static/media/paisaje-medium.ef3aa7b2.jpg";